<template>
    <div >
        <div v-if="!isSend">
            <div class="form-group">
                Введите e-mail, указанный при регистрации
            </div>
            <div class="form-group">
                <input type="email" name="email" v-model="formParams.email" placeholder="введите email..." class="form-control"  >
            </div>
            <button class="btn btn-warning btn-custom" @click="register">Выслать пароль</button>
        </div>
        <div v-else>
            <h5>Пароль был успешно выслан на почту. Проверьте почтовый ящик и перейдите по ссылке, указанной в письме.</h5>
        </div>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
    </div>
</template>

<script>
    export default {
        name: "RememberPasswordForm",
        data() {
            return {
                formParams: {},
                isSend: false,
            }
        },
        methods: {
            register() {
                const check = {
                    'email' : 'E-mail'
                }

                for (var prop in check) {
                    if(!this.formParams[prop]){
                        this.$modal.show('dialog', {
                            title: 'Ошибка',
                            text: 'Не заполнено поле ' + check[prop],
                            buttons: [{ title: 'Закрыть' }]
                        })
                        return;
                    }
                }

                this.$http.post('/remember-password', this.formParams).then( response => {
                    const userData = response.data
                    this.$modal.show('dialog', {
                        title: userData.email ? 'Пароль выслан' : 'Ошибка восстановления',
                        text: userData.email ? 'Пароль успешно выслан на почту. Проверьте почтовый ящик и перейдите по ссылке, указанной в письме.' : 'Пользователь с таким имейлом не найден, проверьте правильность написания или <a href="/registration-form" style="text-decoration: underline;">зарегистрируйтесь.</a>',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                    if(userData.email){
                        this.isSend = true;
                    }
                }, error => {
                    error
                    this.$modal.show('dialog', {
                        title: 'Ошибка восстановления',
                        text: error.message || 'Пользователь с таким имейлом не найден, проверьте правильность написания или <a href="/registration-form">зарегистрируйтесь.</a>',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>